import { createFileRoute } from '@tanstack/react-router';
import { XCallbackHandler } from '../features/x-twitter/callback-handler.tsx';

export const Route = createFileRoute('/x-callback')({
  component: XCallbackHandler,
  validateSearch: (search) => {
    return {
      code: search.code,
      state: search.state,
      error: search.error,
    };
  },
});
